import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from 'react-router-dom';

import { AdminI18nProvider } from '../i18n/provider';
import { router } from '../router';
import { AdminAuthProvider } from './providers/AdminAuthProvider';

const queryClient = new QueryClient();

// PARA-106 §3/§7 (UI-архитектура) — точка входа: QueryClientProvider →
// AdminI18nProvider → AdminAuthProvider → RouterProvider.
export function App(): JSX.Element {
  return (
    <QueryClientProvider client={queryClient}>
      <AdminI18nProvider>
        <AdminAuthProvider>
          <RouterProvider router={router} />
        </AdminAuthProvider>
      </AdminI18nProvider>
    </QueryClientProvider>
  );
}
